import { PropertyType } from '@ha/algolia';
import {
  ListingCancellationPolicy,
  ListingExclusion,
} from 'ha/services/apiV2/types/Listing';
import { Currency } from 'ha/constants/Currencies';

export type UtilityBills = 'I' | 'E' | 'P';

export enum UtilityBillsValues {
  INCLUDED = 'I',
  EXCLUDED = 'E',
  PARTIALLY = 'P',
}

export type SimplifiedListingExclusion = Pick<ListingExclusion, 'from' | 'to'>;

export interface NormalizedAlgoliaListing {
  id: number;
  advertiserId?: number;
  price: number;
  currency: Currency;
  street: string;
  city: string;
  isNew: boolean;
  previewImage: string;
  photos?: string[];
  photoCount: number;
  floorPlanCount: number;
  videoCount: number;
  minimalRentalPeriod: number;
  listingPath: string;
  propertyType: PropertyType;
  exclusions?: Array<{
    from: string;
    to: string;
  }>;
  bedroomFurnished?: string;
  utilities: UtilityBills;
  bedroomCount?: string;
  totalSize?: string;
  bedroomSize?: string;
  currentOccupancy?: number;
  freePlaces?: number;
  registrationPossible?: string;
  cPolicy?: ListingCancellationPolicy;
  priceType?: string;
  minPrice?: number;
  maxPrice?: number;
}
